import { DOCUMENT_REVIEW_STATUSES, DOCUMENT_VALIDITY_STATUSES } from './constant';
import { parseDocumentDate } from './document-date';
import { DEFAULT_ACCEPTED_DOCUMENTS, getPrimaryUploadDocuments } from './accepted-documents';

export const SUPPORTING_DOCUMENTS_MESSAGE = 'Supporting documents alone do not verify your identity. Please provide an approved, valid primary identity document.';

const documentStatusLabels = {
  [DOCUMENT_REVIEW_STATUSES.approved]: 'Approved',
  [DOCUMENT_REVIEW_STATUSES.pending]: 'Pending review',
  [DOCUMENT_REVIEW_STATUSES.rejected]: 'Rejected',
  [DOCUMENT_VALIDITY_STATUSES.valid]: 'Valid',
  [DOCUMENT_VALIDITY_STATUSES.expiringSoon]: 'Expiring Soon',
  [DOCUMENT_VALIDITY_STATUSES.expired]: 'Expired',
};

export const formatDocumentStatus = (status) => documentStatusLabels[status] || 'Unknown';

export const formatDocumentExpiryDate = (value) => {
  if (!value || typeof value !== 'string') return 'Not available';
  const date = new Date(parseDocumentDate(value));
  if (Number.isNaN(date.getTime())) return 'Not available';
  return new Intl.DateTimeFormat('en-GB', {
    day: '2-digit', month: 'short', year: 'numeric', timeZone: 'UTC',
  }).format(date);
};

export const getPrimaryDocumentMessage = (status, acceptedDocuments = DEFAULT_ACCEPTED_DOCUMENTS) => {
  if (!status.hasPrimary) {
    if (status.hasSupporting) return SUPPORTING_DOCUMENTS_MESSAGE;
    const choices = getPrimaryUploadDocuments(acceptedDocuments);
    return choices.length
      ? `Upload a primary identity document (${choices.map((entry) => entry.title).join(', ')}).`
      : 'No documents are available for manual upload. Please check available verification methods or contact support.';
  }
  if (!status.eligible) {
    if (status.pending) {
      return 'Your identity document is under review. Please wait for approval.';
    }
    if (status.rejected) {
      return 'Your identity document was rejected. Please replace it.';
    }
    if (status.expired) {
      return 'Your identity document has expired. Please replace it.';
    }
  }
  return 'Your account requires verification. Review your documents.';
};
